import React from 'react';
import { MySubscriptionsViewProps } from '../types';
import MySubscriptionsContent from '../components/MySubscriptionsContent/index.web';

const MySubscriptionsScreen = (props: MySubscriptionsViewProps) => {
    return <MySubscriptionsContent.Main {...props} />;
};

export default MySubscriptionsScreen;
